import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

// Make sure it hasn't already been initialized
if (!firebase.apps.length) {
  firebase.initializeApp({
    apiKey: "AIzaSyBuSteNXOTv8HunaPpBRYYmJA5FfTEhI40",
    authDomain: "hunt-31a8a.firebaseapp.com",
    databaseURL: "https://hunt-31a8a.firebaseio.com",
    projectId: "hunt-31a8a",
    storageBucket: "hunt-31a8a.appspot.com",
    messagingSenderId: "33567293080",
    appId: "1:33567293080:web:48d54abdbb9965274b1aed",
    measurementId: "G-DZ9YQ1169T"
  });
}

export default firebase;
